import { useState, useEffect } from "react";

const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (token) {
      localStorage.setItem("token", token);
      window.history.replaceState({}, document.title, "/");
    }

    const savedToken = localStorage.getItem("token");

    // ✅ 게스트 토큰 처리 추가
    // const role = localStorage.getItem("role");
    // if (savedToken && role === "GUEST") {
    //   setUser({ nickname: "게스트", role: "GUEST", profileImage: null });
    //   setLoading(false);
    //   return;
    // }

    if (savedToken) {
      fetch("/api/auth/me", {
        headers: { Authorization: `Bearer ${savedToken}` },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.error) {
            localStorage.removeItem("token");
          } else {
            setUser(data);
          }
        })
        .catch(() => localStorage.removeItem("token"))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const logout = () => {
    localStorage.removeItem("token");
    //localStorage.removeItem("role");       // ✅ 게스트 role도 제거
    localStorage.removeItem("nickname");
    setUser(null);
  };

  return { user, loading, logout };
};

export default useAuth;